class DrawerSearchSection extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.drawerClass = "wt-drawer-search";
    this.drawer = document.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--active`;
    this.pageOverlayClass = "search-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;

    this.triggerQuery = [
      ".wt-header__search-trigger",
      ".wt-header__search__close",
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);

    // search stuff
    this.cachedResults = {};
    this.input = this.querySelector('input[name="q"]');
    this.clearButton = this.querySelector(".wt-header__search__clear-button");
    this.closeButton = this.querySelector(".wt-header__search__close");
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]",
    );
    this.mainTrigger = this.querySelector(".wt-header__search-trigger");
    this.emptyAnnouncement = this.querySelector(".search-empty");

    this.isVisibleClearButton = false;

    this.saveSuggestionMenuInDesignMode =
      this.saveSuggestionMenuInDesignMode.bind(this);
    this.setupEventListeners();

    this.toggleTabindexElements = [this.input, this.closeButton];

    this.init();
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input:not([type='hidden']), select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  // fixOverlayIssue() {
  //     const body = this.body;
  //
  //     if(body.classList.contains(this.activeOverlayBodyClass)) {
  //         const offsetTop = -parseInt(body.style.top);
  //         body.style.position = 'initial';
  //         body.style.top = 'initial';
  //         body.style.left = 'initial';
  //         window.scrollTo(0, offsetTop);
  //
  //     } else {
  //         // body.style.top = -document.documentElement.scrollTop+'px';
  //         // body.style.left = '0px';
  //         // body.style.position = 'fixed';
  //     }
  // }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      setTabindex(this.toggleTabindexElements, "-1");
      setTabindex([this.mainTrigger], "0");
      this.isOpen = false;
      setTimeout(() => {
        this.mainTrigger.focus();
      }, 0);
    } else {
      this.setAttribute("open", "");
      setTabindex(this.toggleTabindexElements, "0");
      setTabindex([this.mainTrigger], "-1");
      this.input.focus();
      this.input.dispatchEvent(new MouseEvent("mousedown", { bubbles: true })); // Vianney: en celular/tablet Searchanise solo muestra sugerencias si se toca la barra; así salen desde que se abre la lupa
      this.isOpen = true;
    }
  }

  toggleDrawerClasses() {
    this.onToggle();
    // this.fixOverlayIssue();
    this.drawer.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);
  }

  init() {
    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    // Vianney: al tocar fuera de la barra (o la flecha de regreso de Searchanise) se cierra la búsqueda; antes la página quedaba bloqueada hasta tocar la X
    this.addEventListener("click", (e) => {
      if (this.isOpen && e.target === this) this.toggleDrawerClasses();
    });
    document.addEventListener("click", (e) => {
      if (this.isOpen && e.target.closest(".snize-close-button")) this.toggleDrawerClasses();
    });

    // Vianney: Enter siempre busca. Si Searchanise aún no termina de cargar, se "come" el Enter y no pasaba nada la primera vez
    this.addEventListener(
      "keydown",
      (e) => {
        if (e.key !== "Enter" || e.target !== this.input || !this.getQuery()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.goToResults();
      },
      true,
    );

    this.clearButton.addEventListener("click", () => {
      this.input.value = "";
      this.clearButton.style.display = "none";
      this.isVisibleClearButton = false;
      this.clearResults();
    });

    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (this.isOpen) {
          if (e.shiftKey && document.activeElement === first) {
            last.focus();
            e.preventDefault();
          } else if (!e.shiftKey && document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    });

    this.input.addEventListener("input", () => {
      if (this.input.value.length > 0 && !this.isVisibleClearButton) {
        this.clearButton.style.display = "flex";
        this.clearButton.setAttribute("tabindex", "0");
        this.isVisibleClearButton = true;
      } else if (this.input.value.length === 0 && this.isVisibleClearButton) {
        this.clearButton.style.display = "none";
        this.clearButton.setAttribute("tabindex", "-1");
        this.isVisibleClearButton = false;
      }
    });
  }

  // search stuff
  setupEventListeners() {
    const form = this.querySelector("form.store-search-form");
    form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    if (Shopify.designMode) {
      document.addEventListener(
        "shopify:section:load",
        this.saveSuggestionMenuInDesignMode,
      );
    }
  }

  saveSuggestionMenuInDesignMode() {
    if (this.body.classList.contains(this.activeOverlayBodyClass))
      this.drawer.classList.toggle(this.classDrawerActive);
  }

  getQuery() {
    return this.input.value.trim();
  }

  // Vianney: una sola página de resultados (Searchanise), también desde el botón "Ir" del teclado del celular
  goToResults() {
    window.location.href = `/pages/search-results-page?q=${encodeURIComponent(this.getQuery())}`;
  }

  onChange() {
    if (!this.predictiveSearchResults) return; // Vianney: resultados del tema desactivados en page-header (búsqueda por app); evita el error "setAttribute of null"
    const searchTerm = this.getQuery();

    if (searchTerm.length) {
      this.getSearchResults(searchTerm);
      this.removeAttribute("empty");
    } else {
      this.clearResults();
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    if (this.getQuery().length) this.goToResults();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent("resources[type]")}=product,page,article,collection,query&${encodeURIComponent("resources[limit_scope]")}=each&${encodeURIComponent("resources[limit]")}=6&${encodeURIComponent("resources[options][fields]")}=title,variants.sku,product_type&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          let error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.setAttribute("results", true);

    this.setLiveRegionResults();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        ?.textContent,
    );
  }

  clearResults() {
    this.input.value = "";
    this.removeAttribute("results");
    this.setAttribute("empty", true);
  }
}

customElements.define("search-drawer", DrawerSearchSection);

// Vianney: Searchanise se cargaba hasta que terminaba toda la página (7-11 s en la primera visita) y lo que el cliente escribía antes no mostraba opciones.
// Lo cargamos en cuanto la página está lista o al tocar la búsqueda; init.js trae su propio candado, así que no se carga dos veces.
(() => {
  const SNIZE_INIT =
    "https://searchserverapi1.com/widgets/shopify/init.js?a=5P2A2g8K1X&shop=vianney-mexico.myshopify.com";

  const loadSearchanise = () => {
    if (window.SearchaniseIncluded || document.querySelector(`script[src="${SNIZE_INIT}"]`)) return;
    const script = document.createElement("script");
    script.src = SNIZE_INIT;
    script.async = true;
    document.head.appendChild(script);
  };

  const onSearchIntent = (e) => {
    if (e.target.closest && e.target.closest("search-drawer, .wt-header__search-trigger")) loadSearchanise();
  };
  document.addEventListener("pointerdown", onSearchIntent, true);
  document.addEventListener("focusin", onSearchIntent, true);

  if ("requestIdleCallback" in window) {
    requestIdleCallback(loadSearchanise, { timeout: 2500 });
  } else {
    setTimeout(loadSearchanise, 1500);
  }

  // Si el cliente ya escribió antes de que cargara, mostramos las opciones de lo que ya escribió
  document.addEventListener("Searchanise.Loaded", () => {
    setTimeout(() => {
      const input = document.querySelector('search-drawer input[name="q"]');
      if (!input || document.activeElement !== input || !input.value.trim()) return;
      input.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent("keyup", { bubbles: true, key: "a" }));
    }, 300);
  });
})();

// Vianney: la página de resultados de Searchanise con el mismo look de las colecciones (PLP).
// Solo aplica en /pages/search-results-page; así todo vive en este archivo.
if (location.pathname.indexOf("/pages/search-results-page") === 0) {
  document.body.classList.add("vy-search-page");
  const style = document.createElement("style");
  style.textContent = `
    .vy-search-page .wt-page--compact { max-width: none; padding-left: 16px; padding-right: 16px; }

    #snize_results.snize,
    #snize_results.snize :is(div, span, a, b, li, label, button, input) { font-family: "Latino Gothic", sans-serif !important; }

    /* Rejilla: 2 columnas en celular, 3 en PC, 8px entre tarjetas (igual que la PLP) */
    #snize_results.snize ul.snize-search-results-content {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 32px 8px;
      width: auto !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    #snize_results.snize ul.snize-search-results-content::before,
    #snize_results.snize ul.snize-search-results-content::after { display: none !important; }
    #snize_results.snize li.snize-product {
      float: none !important;
      width: auto !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    #snize_results.snize li.snize-product,
    #snize_results.snize .snize-view-link { border: 0 !important; box-shadow: none !important; }

    /* Tarjeta: foto vertical, título y precio; sin descripción, talla ni botón */
    #snize_results.snize .snize-item {
      height: auto !important;
      padding: 0 !important;
      border: 0 !important;
      box-shadow: none !important;
      background: none !important;
      text-align: left !important;
    }
    #snize_results.snize .snize-thumbnail-wrapper {
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }
    #snize_results.snize .snize-thumbnail {
      display: block !important;
      width: 100% !important;
      height: auto !important;
      aspect-ratio: 4 / 5;
      overflow: hidden;
    }
    #snize_results.snize .snize-thumbnail img {
      position: static !important;
      width: 100% !important;
      height: 100% !important;
      max-width: none !important;
      max-height: none !important;
      object-fit: cover;
      transform: none !important;
    }
    #snize_results.snize .snize-overhidden { margin: 0 !important; padding: 0 !important; text-align: left !important; }
    #snize_results.snize .snize-title {
      display: block !important;
      max-height: none !important;
      margin: 16px 0 0 !important;
      font-size: 12px !important;
      line-height: 18px !important;
      font-weight: 700 !important;
      text-transform: uppercase;
      text-align: left !important;
      color: #000 !important;
    }
    #snize_results.snize .snize-price-list { display: block !important; margin: 0 !important; padding: 0 !important; text-align: left !important; }
    #snize_results.snize .snize-price-list .snize-price {
      display: inline !important;
      margin: 0 !important;
      padding: 0 !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      text-align: left !important;
      color: #000 !important;
    }
    #snize_results.snize .snize-description,
    #snize_results.snize .snize-options-box,
    #snize_results.snize .snize-buttons,
    #snize_results.snize .snize-main-panel-view-mode { display: none !important; }

    /* Pestañas simples y botones Ordenar / Filtros como los de la PLP */
    #snize_results.snize .snize-main-panel {
      display: flex !important;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      width: auto !important;
      max-width: 100% !important;
      margin: 0 0 24px !important;
      padding: 0 !important;
      box-sizing: border-box;
    }
    #snize_results.snize .snize-main-panel-controls { flex: 0 0 100%; float: none !important; margin: 0 !important; }
    #snize_results.snize .snize-main-panel-controls ul { box-shadow: none !important; border-radius: 0 !important; }
    #snize_results.snize .snize-main-panel-controls a { border-radius: 0 !important; background: none !important; color: #000 !important; }
    #snize_results.snize .snize-main-panel-controls a.active { border-bottom: 2px solid #000 !important; }
    #snize_results.snize .snize-main-panel-dropdown,
    #snize_results.snize .snize-main-panel-mobile-filters {
      position: relative;
      flex: 1 1 0 !important;
      float: none !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      margin: 0 !important;
      border: 0 !important;
      background: none !important;
      box-shadow: none !important;
    }
    #snize_results.snize a.snize-main-panel-dropdown-button,
    #snize_results.snize .snize-main-panel-mobile-filters button {
      display: flex !important;
      align-items: center;
      justify-content: center;
      gap: 8px;
      box-sizing: border-box !important;
      width: 100% !important;
      height: 40px !important;
      margin: 0 !important;
      padding: 0 16px !important;
      border: 0 !important;
      border-radius: 4px !important;
      background: #97788c !important;
      color: #fbfafa !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      text-transform: none !important;
    }
    #snize_results.snize a.snize-main-panel-dropdown-button * { color: #fbfafa !important; text-transform: none !important; }
    #snize_results.snize a.snize-main-panel-dropdown-button .caret { position: static !important; margin: 0 !important; border-top-color: #fbfafa !important; }

    @media (min-width: 900px) {
      .vy-search-page .wt-page--compact { padding-left: 32px; padding-right: 32px; }
      #snize_results.snize .snize-main-panel-controls { flex: 1 1 auto; }
      #snize_results.snize .snize-main-panel-dropdown { flex: 0 0 220px !important; }
      #snize_results.snize ul.snize-search-results-content { grid-template-columns: repeat(3, minmax(0, 1fr)); }
      #snize_results.snize .snize-thumbnail { aspect-ratio: 424 / 572; }
      #snize_results.snize .snize-title { font-size: 15px !important; line-height: 22.5px !important; }
      #snize_results.snize .snize-price-list .snize-price { font-size: 15px !important; }
    }
  `;
  document.head.appendChild(style);
}
